import i, { useState as o, useMemo as l, useEffect as y } from "react";
import { DateTime as H } from "luxon";
import { useWindowEvent as b } from "../../../../../features/dom/hooks/useWindowEvent.js";
import { nearestQuarterHour as w } from "../../../../../utils.js";
const d = i.createContext({});
function x() {
  return i.useContext(d);
}
function J() {
  const { currentStep: r } = x();
  return r;
}
function N({
  children: r
}) {
  const [u, v] = o([]), [c, S] = o(!1), { dispatchEvent: g } = b(), k = l(() => {
    const f = H.local();
    return w(f).toFormat("HH:mm");
  }, []), [e, a] = o({
    place: null,
    people: 1,
    marketingPermissions: !1,
    hour: k,
    bookingPolicy: !1
  });
  y(() => {
    typeof window !== void 0 && (window.booking = JSON.parse(JSON.stringify(e)), g("formChange", {
      booking: e
    }));
  }, [e]);
  const [m, p] = o({
    name: "reservation",
    data: void 0
  }), C = l(() => ({
    form: e,
    setForm: a,
    currentStep: m,
    active: c,
    setIsActive: S,
    setCurrentStep: (t) => {
      p((n) => (v((s) => [
        ...s,
        n
      ]), t));
    },
    setFormValue: (t, n) => {
      a((s) => ({
        ...s,
        [t]: n
      }));
    },
    back: () => {
      const t = u.pop();
      t !== void 0 && p(t);
    }
  }), [e, m, u, c]);
  return /* @__PURE__ */ i.createElement(d.Provider, { value: C }, r);
}
export {
  N as BookingProvider,
  x as useBooking,
  J as useBookingStep
};
//# sourceMappingURL=context.js.map
